import {
  FETCH_ERRORS
} from './mutations-types'
import firebase from '../../../firebase/main'
import helpers from '../../../helpers/functions'

export default {
  fetchErrors ({ commit, dispatch }, payload) {
    return new Promise(resolve => {
      resolve(firebase.Errors.fetchErrors())
    })
      .then(res => {
        commit(FETCH_ERRORS, res)
      })
      .catch(err => helpers.handleError(err))
  }
}
